import { DEFAULT_LIMIT } from '../constants/pagination';
import { IGetProjectsListV2Response } from '../repositories/countryside-constructors/entities/v2_entities/GetProjectsListV2Response';
import { IBuildersProjectsData, IProject } from '../types/buildersProjects';

export const prepareBuildersProjectsData = (response: IGetProjectsListV2Response): IBuildersProjectsData => {
  return {
    page: response.page || 0,
    limit: response.limit || DEFAULT_LIMIT,
    total: response.total || 0,
    projectsList: response.projectsList as IProject[],
    location: response.location,
    breadcrumbs: response.breadcrumbs,
  };
};
